// ~/avaai_dashboard/frontend/src/pages/Setup.tsx
import React, { useState } from "react";

export default function Setup() {
  const [displayName, setDisplayName] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [ageRange, setAgeRange] = useState("");
  const [themeColor, setThemeColor] = useState("cyan");
  const [contactEmail, setContactEmail] = useState("");
  
console.log("DEBUG: handleSubmit fired");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    console.log("Submitting profile to /api/v1/auth/profile"); // helpful debug line

    const res = await fetch("/api/v1/auth/profile", {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        display_name: displayName,
        city,
        state,
        age_range: ageRange,
        theme_color: themeColor,
        contact_email: contactEmail || null,
      }),
    });

    if (!res.ok) {
      console.error("Profile save failed", await res.text());
      console.error("Profile save failed. Please try again.");
      return;
    }

    // success – redirect to dashboard
    window.location.href = "/dashboard";
  }

  return (
    <div className="min-h-screen flex flex-col bg-black text-white relative overflow-hidden">
      {/* neon background layers */}
      <div className="absolute inset-0 animate-gradient bg-gradient-to-r from-cyan-500 via-purple-600 to-pink-500 blur-3xl opacity-30"></div>
      <div className="absolute inset-0 bg-black/40"></div>

      <main className="flex flex-col items-center justify-center flex-grow z-10 px-6 pt-12 pb-16">
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-wide text-[var(--neon-color)] drop-shadow-[0_0_30px_var(--neon-color)] mb-10 text-center">
          Setup Your Profile
        </h1>

        <form
          onSubmit={handleSubmit}
          className="w-full max-w-md bg-black/60 p-8 rounded-lg shadow-[0_0_30px_var(--neon-color)] border border-[var(--neon-color)]"
        >
          <label className="block mb-4">
            Display Name
            <input
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              required
              className="w-full p-2 mt-1 rounded bg-gray-900 border border-gray-600 focus:outline-none focus:border-[var(--neon-color)] focus:ring-2 focus:ring-[var(--neon-color)]"
            />
          </label>

          <label className="block mb-4">
            City
            <input
              type="text"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="w-full p-2 mt-1 rounded bg-gray-900 border border-gray-600 focus:outline-none focus:border-[var(--neon-color)] focus:ring-2 focus:ring-[var(--neon-color)]"
            />
          </label>

          <label className="block mb-4">
            State
            <input
              type="text"
              value={state}
              onChange={(e) => setState(e.target.value)}
              className="w-full p-2 mt-1 rounded bg-gray-900 border border-gray-600 focus:outline-none focus:border-[var(--neon-color)] focus:ring-2 focus:ring-[var(--neon-color)]"
            />
          </label>

          <label className="block mb-4">
            Age Range
            <select
              value={ageRange}
              onChange={(e) => setAgeRange(e.target.value)}
              className="w-full p-2 mt-1 rounded bg-gray-900 border border-gray-600 focus:outline-none focus:border-[var(--neon-color)] focus:ring-2 focus:ring-[var(--neon-color)]"
            >
              <option value="">--Choose--</option>
              <option value="under-18">Under 18 (with parent/guardian)</option>
              <option value="18-24">18-24</option>
              <option value="25-34">25-34</option>
              <option value="35-44">35-44</option>
              <option value="45+">45+</option>
            </select>
          </label>

          <label className="block mb-4">
            Contact Email (optional)
            <input
              type="email"
              value={contactEmail}
              onChange={(e) => setContactEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full p-2 mt-1 rounded bg-gray-900 border border-gray-600 focus:outline-none focus:border-[var(--neon-color)] focus:ring-2 focus:ring-[var(--neon-color)]"
            />
          </label>

          <label className="block mb-6">
            Theme Color
            <select
              value={themeColor}
              onChange={(e) => setThemeColor(e.target.value)}
              className="w-full p-2 mt-1 rounded bg-gray-900 border border-gray-600 focus:outline-none focus:border-[var(--neon-color)] focus:ring-2 focus:ring-[var(--neon-color)]"
            >
              <option value="cyan">Cyan</option>
              <option value="purple">Purple</option>
              <option value="green">Green</option>
              <option value="red">Red</option>
              <option value="blue">Blue</option>
              <option value="orange">Orange</option>
              <option value="yellow">Yellow</option>
            </select>
          </label>

          <button
            type="submit"
            className="w-full py-3 rounded bg-[var(--neon-color)] text-black font-bold text-lg hover:opacity-90 hover:scale-105 transition transform"
          >
            Save & Continue
          </button>
        </form>
      </main>

      <footer className="text-center text-[10px] md:text-xs text-white/60 px-3 py-6 border-t border-white/10 z-10">
        <div className="space-x-3">
          <a href="/privacy-policy" className="underline text-[var(--neon-color)] hover:text-white">Privacy Policy</a>
          <span className="text-gray-500">•</span>
          <a href="/terms-and-conditions" className="underline text-[var(--neon-color)] hover:text-white">Terms & Conditions</a>
          <span className="text-gray-500">•</span>
          <a href="/credits" className="underline text-[var(--neon-color)] hover:text-white">Credits & Attributions</a>
        </div>

        <div className="mt-2 font-medium text-white">
          © {new Date().getFullYear()}{" "}
          <span className="uppercase">AVAAIO<span className="align-super text-sm">™</span></span>
          {" "}— Powered by <strong>American Global™</strong>
        </div>

        <div className="mt-1 text-[9px] text-white/50">
          AVAAIO™ and American Global™ are trademarks of American Globalo, LLC. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
